import CasesTable from './CasesTable';

export default CasesTable;
